/** SurveyJS choice value for «Ingen kategori» (empty string is unreliable in dropdowns). */
export const EVENT_CATEGORY_NONE_FORM_VALUE = '__event_category_none__';

export function eventCategoryToFormValue(
  category: string | null | undefined
): string {
  if (category === null || category === undefined) {
    return EVENT_CATEGORY_NONE_FORM_VALUE;
  }
  const trimmed = String(category).trim();
  if (trimmed === '') {
    return EVENT_CATEGORY_NONE_FORM_VALUE;
  }
  return trimmed;
}

export function eventCategoryFromFormValue(raw: unknown): string | null {
  if (raw === null || raw === undefined) {
    return null;
  }
  if (raw === EVENT_CATEGORY_NONE_FORM_VALUE || raw === '') {
    return null;
  }
  const trimmed = String(raw).trim();
  if (trimmed === '' || trimmed === EVENT_CATEGORY_NONE_FORM_VALUE) {
    return null;
  }
  return trimmed;
}
